import * as React from "react";
function SvgTwitch(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <path
        fill="#fff"
        d="M7.24 6.67l-1.43 3.66v15h5.1V28h2.86l2.71-2.71h4.14l5.57-5.57v-13zm17 12.1L21.09 22H16l-2.71 2.71V22H9V8.58h15.28zm-5.1-6.53h1.91v5.57h-1.87zm-5.09 0H16v5.57h-1.91z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTwitch);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
